import React, { createContext, useContext, useState } from 'react';
import { fetchPostData } from '@/Components/hooks/Api';

const OffenseContext = createContext();

export const OffenseProvider = ({ children }) => {
  const [offenceShowPage, setOffenceShowPage] = useState('home');
  const [offenceStatus, setOffenceStatus] = useState();
  const [offenseCount, setOffenseCount] = useState([]);
  const [offenseChargeCount, setoffenseChargeCount] = useState('');
  const [countoff, setcountoff] = useState(false);
  const [countoffaduit, setcountoffaduit] = useState(false);
  const [countoffaduitAgency, setcountoffaduitAgency] = useState(false);
  const [countaduitprsonel, setcountaduitprsonel] = useState(false);
  const [PanelCode, setPanelCode] = useState();

  const get_Offence_Count = (CrimeID) => {
    fetchPostData('HomeApi/GetData_OffenseCount', { CrimeID }).then((res) => {
      setOffenseCount(res?.[0] || []);
    });
  };

  return (
    <OffenseContext.Provider
      value={{
        offenceShowPage,
        setOffenceShowPage,
        offenceStatus,
        setOffenceStatus,
        offenseCount,
        setOffenseCount,
        offenseChargeCount,
        setoffenseChargeCount,
        countoff,
        setcountoff,
        countoffaduit,
        setcountoffaduit,
        countoffaduitAgency,
        setcountoffaduitAgency,
        countaduitprsonel,
        setcountaduitprsonel,
        PanelCode,
        setPanelCode,
        get_Offence_Count,
      }}
    >
      {children}
    </OffenseContext.Provider>
  );
};

export const useOffense = () => {
  const context = useContext(OffenseContext);
  if (!context) throw new Error('useOffense must be used within OffenseProvider');
  return context;
};

export default OffenseContext;
